<div class="border border-grey rounded-3" style="background-color:  #efefef;">
    <input type="file" class="form-control border-0 border-bottom border-dark rounded-0" (change)="onUploadChange($event)" accept=".png, .jpg, .jpeg, .webp, .gif" [disabled]="is_loading"/>
    <div class="d-flex flex-row gap-2 justify-content-center align-items-center mt-2" *ngIf="is_loading" >
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <span>Uploading Image</span>
    </div>
    <div class="d-flex flex-column gap-3 p-3" cdkDropList (cdkDropListDropped)="drop($event)">
        <div class="d-flex flex-row" *ngFor="let img of files; let i = index" cdkDrag>
            <div class="position-relative w-100">
                <img class="w-50 bg-black" [src]="img" />
                <button type="button" (click)="delete(i)" [disabled]="is_loading" class="position-absolute btn btn-danger top-0 end-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                    </svg>
                </button>
            </div>
        </div>
        <p *ngIf="files.length == 0" class="px-1 mb-0">Click on the choose file button to upload image.</p>
    </div>
    <p *ngIf="error" class="text-danger px-3" role="alert">{{ error }}</p>
</div>
